"use client";

import { logService } from "@/services";
import { useRouter } from "next/router";
import { useEffect } from "react";

// Public routes have no Supabase session, so there is nothing to log there.
const PUBLIC_ROUTES = ["/login", "/register", "/password-reset"];

const logPageView = (path: string) => {
  const pathname = path.split("?")[0];
  if (PUBLIC_ROUTES.includes(pathname)) return;
  // Log the full path incl. query string so the exact view can be recreated.
  // Fire-and-forget: usage logging must never block or break the UI.
  logService.logUsage("page_view", path).catch(() => {});
};

export const UsageLogger = () => {
  const router = useRouter();

  useEffect(() => {
    logPageView(router.asPath);

    router.events.on("routeChangeComplete", logPageView);
    return () => {
      router.events.off("routeChangeComplete", logPageView);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
